var map = {
	"./addons/schedule.js": "0461",
	"./announcemettypes/notifications.js": "da39",
	"./assignment/assignment.js": "f876",
	"./attendance/attendance.js": "0657",
	"./auth/auth.js": "e908",
	"./base/base.js": "b531",
	"./birthday/birthday.js": "c4a1",
	"./campusadmin/campusadmin.js": "40ee",
	"./campuses/campuses.js": "852f",
	"./chapter/chapter.js": "c0ec",
	"./classattendance/classattendance.js": "6976",
	"./classes/classes.js": "5762",
	"./csv/csv.js": "11f5",
	"./exams/exams.js": "7866",
	"./expense/student.js": "0a5f",
	"./featureNaming/schedule.js": "59a3",
	"./fee/fee.js": "b1ec",
	"./guardian/guardian.js": "6869",
	"./inputFields/inputs.js": "5bc4",
	"./institute/institute.js": "b9fb",
	"./instituteCount/instituteCount.js": "9699",
	"./layout/layout.js": "42da",
	"./lesson/lesson.js": "7d88",
	"./noticeboard/noticeboard.js": "98ed",
	"./notifications/notifications.js": "f335",
	"./paymentMethods/paymentMethods.js": "8ade",
	"./period/schedule.js": "490b",
	"./pickup/pickup.js": "34fe",
	"./registration/registration.js": "a740",
	"./room/room.js": "4ad3",
	"./routine/routine.js": "beed",
	"./salary/salary.js": "cfce",
	"./section/section.js": "da5d",
	"./settings/settings.js": "3399",
	"./staff/staff.js": "a846",
	"./student/student.js": "d0ae",
	"./subjects/subjects.js": "6de5",
	"./superadmin/superadmin.js": "154a",
	"./supportQuery/query.js": "43ce",
	"./syllabusmanager/student.js": "20f5",
	"./tab/tab.js": "49e2",
	"./teacher/teacher.js": "2cfb",
	"./toast/toast.js": "cf13",
	"./users/user.js": "403c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8e33";